import React from "react";
import {formatCopy} from 'utils/typography';
import './delivery-type.scss';
import {LinkPopover} from '@vedmarket/ui-kit';
import FormControl from '@mui/material/FormControl';
import { METHODS } from '../../index'
import {useTranslation} from "react-i18next";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {useDemoDeliveryType} from 'components/cabinet/demo/steps/packaging/use-packaging';

const DeliveryType = ({demoDeliveryMethod, deliveryMethod, setDeliveryMethod, isModal}: PackagingDeliveryTypeProps) => {

  const { t } = useTranslation()

  const containerTypes = t('calc__help__deliveryMethodContainerTypes', {returnObjects: true}) as string[];

  const demoPlayback = useDemoDeliveryType({
    combinedCargo: METHODS.COMBINED_CARGO,
    containers: METHODS.CONTAINERS,
    deliveryMethod,
    demoDeliveryMethod,
    getCombinedCargoText: () => t('calc__text__packaging__combinedCargo'),
    getContainersText: () => t('calc__text__packaging__containers'),
  })

  return <FormControl sx={{ width: '100%', gap: 1 }}>
    {isModal && <Typography variant='h6'>{t('calc__text__packaging__deliveryMethod')}</Typography>}
    <FormControl sx={{ width: '100%', boxSizing: 'border-box' }}>
      <InputLabel id='delivery-method-group-label' shrink><Typography component='span' variant='inherit'>{t('calc__text__packaging__deliveryMethod')}</Typography></InputLabel>
      <Select
        {...demoPlayback.selectProps}
        labelId='delivery-method-group-label'
        id='delivery-method-select'
        notched
        sx={{'& .MuiSelect-select': {padding: '12px 32px 12px 12px'}}}
        label={<Typography component='span' variant='inherit'>{t('calc__text__packaging__deliveryMethod')}</Typography>}
        onChange={({ target: { value: type } }) => setDeliveryMethod(Number(type))}>
        <MenuItem
          {...demoPlayback.combinedCargoProps}
          value={METHODS.COMBINED_CARGO}
        ><Typography component='span' variant='inherit'>{t('calc__text__packaging__combinedCargo')}</Typography></MenuItem>
        <MenuItem
          {...demoPlayback.containersProps}
          value={METHODS.CONTAINERS}
        ><Typography component='span' variant='inherit'>{t('calc__text__packaging__containers')}</Typography></MenuItem>
      </Select>
    </FormControl>
    <LinkPopover
      linkText={t('calc__help__deliveryMethodLink')}
      text={<div className='delivery-method-help'>
        <Typography variant='inherit'>
          {formatCopy(t('calc__help__deliveryMethodIntro'))}
        </Typography>
        <div>
          <Typography variant='inherit'>
            {formatCopy(t('calc__help__deliveryMethodContainersIntro'))}
          </Typography>
          <ul className='delivery-method-help__list'>
            {containerTypes.map(item => <Typography
              key={item}
              component='li'
              variant='inherit'
              className='delivery-method-help__item'
            >
              {formatCopy(item)}
            </Typography>)}
          </ul>
        </div>
      </div>}
    />
  </FormControl>
}

export default DeliveryType
